"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/reward-criteria.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Freward-criteria.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.rewardCriteriaToJSON = exports.rewardCriteriaFromJSON = exports.RewardCriteriaResult = exports.RewardCriteria = void 0;
const protobufPackage = 'com.step.offer.proto';
var RewardCriteria;
(function (RewardCriteria) {
    RewardCriteria["INVALID_REWARD_CRITERIA"] = "INVALID_REWARD_CRITERIA";
    /**
     * TXN_AMOUNT_NEGATIVE - If the transaction amount is negative, that means it is a spend
     */
    RewardCriteria["TXN_AMOUNT_NEGATIVE"] = "TXN_AMOUNT_NEGATIVE";
    /**
     * ABOVE_MIN_TXN_AMOUNT - If the transaction meets the minimum transaction amount for the reward
     */
    RewardCriteria["ABOVE_MIN_TXN_AMOUNT"] = "ABOVE_MIN_TXN_AMOUNT";
    /**
     * MERCHANT_NAME_MATCHES - If specified, does the transaction merchant name any of the given names
     */
    RewardCriteria["MERCHANT_NAME_MATCHES"] = "MERCHANT_NAME_MATCHES";
    /**
     * MERCHANT_NETWORK_ID_MATCHES - If specified, does the transaction network ID match as any of the given IDs
     */
    RewardCriteria["MERCHANT_NETWORK_ID_MATCHES"] = "MERCHANT_NETWORK_ID_MATCHES";
    /**
     * PAYOUT_LIMIT_EXHAUSTED - If the payout limits for reward were exhausted
     */
    RewardCriteria["PAYOUT_LIMIT_EXHAUSTED"] = "PAYOUT_LIMIT_EXHAUSTED";
    /**
     * ABOVE_MIN_FUNDING_AMOUNT - If the funding transaction meets minimum funding amount for the reward
     */
    RewardCriteria["ABOVE_MIN_FUNDING_AMOUNT"] = "ABOVE_MIN_FUNDING_AMOUNT";
    /**
     * WALLET_PROVIDER_MATCHES - If specified, does the transaction wallet provider name match any of the given names.
     */
    RewardCriteria["WALLET_PROVIDER_MATCHES"] = "WALLET_PROVIDER_MATCHES";
    /**
     * MERCHANT_CATEGORY_MATCHES - If specified, does the transaction category (mcc ID) match as any of the given IDs
     */
    RewardCriteria["MERCHANT_CATEGORY_MATCHES"] = "MERCHANT_CATEGORY_MATCHES";
    /**
     * MERCHANT_NAME_OR_CATEGORY_MATCHES - If specified, does the transaction merchant name _or_ category (mcc ID) match.
     */
    RewardCriteria["MERCHANT_NAME_OR_CATEGORY_MATCHES"] = "MERCHANT_NAME_OR_CATEGORY_MATCHES";
    /**
     * MERCHANT_NAME_AND_CATEGORY_MATCHES - If specified, does the transaction merchant name _and_ category (mcc ID) match
     */
    RewardCriteria["MERCHANT_NAME_AND_CATEGORY_MATCHES"] = "MERCHANT_NAME_AND_CATEGORY_MATCHES";
    /**
     * MERCHANT_NAME_SHOULD_NOT_MATCH - If specified, does the transaction merchant not match any of the given names.
     */
    RewardCriteria["MERCHANT_NAME_SHOULD_NOT_MATCH"] = "MERCHANT_NAME_SHOULD_NOT_MATCH";
    /**
     * ABOVE_MIN_PAYMENT_AMOUNT - If the payment meets the minimum spending amount for the reward.
     */
    RewardCriteria["ABOVE_MIN_PAYMENT_AMOUNT"] = "ABOVE_MIN_PAYMENT_AMOUNT";
    RewardCriteria["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RewardCriteria || (exports.RewardCriteria = RewardCriteria = {}));
function createBaseRewardCriteriaResult() {
    return { criteria: RewardCriteria.INVALID_REWARD_CRITERIA, passed: false, failureReason: '' };
}
exports.RewardCriteriaResult = {
    fromJSON(object) {
        const message = {
            criteria: isSet(object.criteria)
                ? rewardCriteriaFromJSON(object.criteria)
                : RewardCriteria.INVALID_REWARD_CRITERIA,
            passed: isSet(object.passed) ? globalThis.Boolean(object.passed) : false,
        };
        if (isSet(object.failureReason)) {
            message.failureReason = globalThis.String(object.failureReason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.criteria !== RewardCriteria.INVALID_REWARD_CRITERIA) {
            obj.criteria = rewardCriteriaToJSON(message.criteria);
        }
        if (message.passed !== false) {
            obj.passed = message.passed;
        }
        if (message.failureReason !== undefined && message.failureReason !== '') {
            obj.failureReason = message.failureReason;
        }
        return obj;
    },
    create(base) {
        return exports.RewardCriteriaResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRewardCriteriaResult();
        message.criteria = object.criteria ?? RewardCriteria.INVALID_REWARD_CRITERIA;
        message.passed = object.passed ?? false;
        message.failureReason = object.failureReason ?? '';
        return message;
    },
};
function rewardCriteriaFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REWARD_CRITERIA':
            return RewardCriteria.INVALID_REWARD_CRITERIA;
        case 1:
        case 'TXN_AMOUNT_NEGATIVE':
            return RewardCriteria.TXN_AMOUNT_NEGATIVE;
        case 2:
        case 'ABOVE_MIN_TXN_AMOUNT':
            return RewardCriteria.ABOVE_MIN_TXN_AMOUNT;
        case 3:
        case 'MERCHANT_NAME_MATCHES':
            return RewardCriteria.MERCHANT_NAME_MATCHES;
        case 4:
        case 'MERCHANT_NETWORK_ID_MATCHES':
            return RewardCriteria.MERCHANT_NETWORK_ID_MATCHES;
        case 5:
        case 'PAYOUT_LIMIT_EXHAUSTED':
            return RewardCriteria.PAYOUT_LIMIT_EXHAUSTED;
        case 6:
        case 'ABOVE_MIN_FUNDING_AMOUNT':
            return RewardCriteria.ABOVE_MIN_FUNDING_AMOUNT;
        case 7:
        case 'WALLET_PROVIDER_MATCHES':
            return RewardCriteria.WALLET_PROVIDER_MATCHES;
        case 8:
        case 'MERCHANT_CATEGORY_MATCHES':
            return RewardCriteria.MERCHANT_CATEGORY_MATCHES;
        case 9:
        case 'MERCHANT_NAME_OR_CATEGORY_MATCHES':
            return RewardCriteria.MERCHANT_NAME_OR_CATEGORY_MATCHES;
        case 10:
        case 'MERCHANT_NAME_AND_CATEGORY_MATCHES':
            return RewardCriteria.MERCHANT_NAME_AND_CATEGORY_MATCHES;
        case 11:
        case 'MERCHANT_NAME_SHOULD_NOT_MATCH':
            return RewardCriteria.MERCHANT_NAME_SHOULD_NOT_MATCH;
        case 12:
        case 'ABOVE_MIN_PAYMENT_AMOUNT':
            return RewardCriteria.ABOVE_MIN_PAYMENT_AMOUNT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RewardCriteria.UNRECOGNIZED;
    }
}
exports.rewardCriteriaFromJSON = rewardCriteriaFromJSON;
function rewardCriteriaToJSON(object) {
    switch (object) {
        case RewardCriteria.INVALID_REWARD_CRITERIA:
            return 'INVALID_REWARD_CRITERIA';
        case RewardCriteria.TXN_AMOUNT_NEGATIVE:
            return 'TXN_AMOUNT_NEGATIVE';
        case RewardCriteria.ABOVE_MIN_TXN_AMOUNT:
            return 'ABOVE_MIN_TXN_AMOUNT';
        case RewardCriteria.MERCHANT_NAME_MATCHES:
            return 'MERCHANT_NAME_MATCHES';
        case RewardCriteria.MERCHANT_NETWORK_ID_MATCHES:
            return 'MERCHANT_NETWORK_ID_MATCHES';
        case RewardCriteria.PAYOUT_LIMIT_EXHAUSTED:
            return 'PAYOUT_LIMIT_EXHAUSTED';
        case RewardCriteria.ABOVE_MIN_FUNDING_AMOUNT:
            return 'ABOVE_MIN_FUNDING_AMOUNT';
        case RewardCriteria.WALLET_PROVIDER_MATCHES:
            return 'WALLET_PROVIDER_MATCHES';
        case RewardCriteria.MERCHANT_CATEGORY_MATCHES:
            return 'MERCHANT_CATEGORY_MATCHES';
        case RewardCriteria.MERCHANT_NAME_OR_CATEGORY_MATCHES:
            return 'MERCHANT_NAME_OR_CATEGORY_MATCHES';
        case RewardCriteria.MERCHANT_NAME_AND_CATEGORY_MATCHES:
            return 'MERCHANT_NAME_AND_CATEGORY_MATCHES';
        case RewardCriteria.MERCHANT_NAME_SHOULD_NOT_MATCH:
            return 'MERCHANT_NAME_SHOULD_NOT_MATCH';
        case RewardCriteria.ABOVE_MIN_PAYMENT_AMOUNT:
            return 'ABOVE_MIN_PAYMENT_AMOUNT';
        case RewardCriteria.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.rewardCriteriaToJSON = rewardCriteriaToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=reward-criteria.js.map